export function determineResultType(answers) {
  let uninsuredScore = 0;
  let overpayingScore = 0;
  let educationScore = 0;

  // Q1: Current coverage status
  if (answers.q1 === 'no' || answers.q1 === 'thought_landlord') {
    uninsuredScore += 5; // Critical - no protection at all
  } else if (answers.q1 === 'not_sure') {
    educationScore += 3;
  } else if (answers.q1 === 'yes') {
    overpayingScore += 2; // Route to optimization path
  }

  // Q2: Belongings value
  if ((answers.q2 === '25k_50k' || answers.q2 === '50k_plus') && answers.q1 !== 'yes') {
    uninsuredScore += 3; // High financial risk
  } else if (answers.q2 === 'no_idea') {
    educationScore += 2;
  }

  // Q3: What matters most
  if (answers.q3 === 'understanding') {
    educationScore += 3;
  } else if (answers.q3 === 'lowest_price') {
    overpayingScore += 2;
  }

  // Q5: Biggest concern
  if (answers.q5 === 'nothing') {
    educationScore += 3; // Needs awareness
  } else if (answers.q5 === 'landlord_req') {
    uninsuredScore += 2; // Urgent compliance need
  } else if (answers.q5 === 'not_sure_enough') {
    overpayingScore += 2;
  } else if (answers.q5 && answers.q5 !== 'nothing') {
    uninsuredScore += 1; // Any concern = need coverage
  }

  // Determine path
  if (uninsuredScore >= 5) return 'uninsured';
  if (overpayingScore >= 3 && educationScore < 3) return 'overpaying';
  return 'education'; // Default for clarity path
}

export function formatCurrency(valueString) {
  const map = {
    'lt_10k': 'Under $10,000',
    '10k_25k': '$10,000 - $25,000',
    '25k_50k': '$25,000 - $50,000',
    '50k_plus': 'Over $50,000',
    'no_idea': 'Unknown Value'
  };
  return map[valueString] || 'Your Belongings';
}